import React, { useCallback, useEffect } from 'react'
import { Button, TextField } from '@dasa-health/components-react'
import { useHistory } from 'react-router-dom'
import { ROUTES_PATH } from 'constants/routesPath'
import { CustomForm } from './styles'
import { Flex, Spacing } from '@dasa-health/alma-react'
import { useCPFLoginForm } from 'redesign/hooks/useCPFLoginForm'
import { useRecoverHook } from 'hooks'
import { userDeviceDetect } from 'utils'

type CustomModalProps = {
    onClose?: () => void
}

export function CustomModalOrBottomSheetLogin({ onClose }: CustomModalProps) {
    const history = useHistory()
    const {
        values,
        errors,
        touched,
        handleBlur,
        handleSubmit,
        isSubmitting,
        handleChangeCpf,
        resetForm,
        isLogin,
        setFieldValue,
    } = useCPFLoginForm()
    const recover = useRecoverHook()
    const { isPortable } = userDeviceDetect()

    const handleRedirectTo = useCallback(() => {
        recover.setUsername(values.cpf)
        const redirectUrl = sessionStorage.getItem('@redirectToUrl') || '/exames?origin=Acesso-Facil'
        sessionStorage.setItem('@LiviaAuth:Campaigns', redirectUrl)
        history.push(ROUTES_PATH.LOGIN_WITH_OTP)
    }, [values.cpf])

    const handleRedirectRegistration = useCallback(() => {
        if (!isLogin) {
            recover.setUsername(values.cpf)
            const redirectUrl = sessionStorage.getItem('@redirectToUrl') || '/exames?origin=Acesso-Facil'
            sessionStorage.setItem('@LiviaAuth:Campaigns', redirectUrl)
            history.push(ROUTES_PATH.SIGN_UP_PERSONAL_DATA)
        }
    }, [values.cpf])

    useEffect(() => {
        const storedCpf = sessionStorage.getItem('cpf')
        if (storedCpf) {
            setFieldValue('cpf', storedCpf)
        }
    }, [setFieldValue])

    useEffect(() => {
        values.cpf.length < 14 && resetForm()
        values.cpf.length === 14 && handleSubmit()
    }, [values.cpf])

    return (
        <CustomForm onSubmit={handleSubmit}>
            <TextField
                autoComplete="username"
                className="textInput"
                helperText={touched.cpf ? errors.cpf : ''}
                inputMode="numeric"
                label="Digite o CPF para acessar ou cadastrar"
                name="cpf"
                onBlur={handleBlur}
                onChange={handleChangeCpf}
                onPaste={() => resetForm()}
                readOnly={isSubmitting}
                style={{ color: '#000', fontSize: '16px' }}
                type="tel"
                value={values.cpf}
                variant={touched.cpf && errors.cpf ? 'error' : 'default'}
            />
            <Spacing height={touched.cpf && errors.cpf ? 16 + 24 : 32} />
            {isPortable ? (
                <Flex flexDirection="row" marginTop={'initial'}>
                    <Button
                        disabled={!values.cpf || !!errors.cpf || isSubmitting}
                        isLoading={isSubmitting}
                        onClick={() => (isLogin ? handleRedirectTo() : '')}
                        width="100%"
                    >
                        {isLogin ? 'Acessar' : 'Continuar cadastro'}
                    </Button>
                </Flex>
            ) : (
                <Flex>
                    <Button onClick={onClose} type="button" variant="tertiary" width="100%">
                        Cancelar
                    </Button>
                    <Spacing width={16} />
                    <Button
                        disabled={!values.cpf || !!errors.cpf || isSubmitting}
                        isLoading={isSubmitting}
                        onClick={() => (isLogin ? handleRedirectTo() : handleRedirectRegistration())}
                        width="100%"
                    >
                        {isLogin ? 'Acessar' : 'Continuar cadastro'}
                    </Button>
                </Flex>
            )}
        </CustomForm>
    )
}
